var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9513 0.526574C23.932 0.438003 23.8895 0.356137 23.8283 0.289333C23.767 0.222529 23.6891 0.17318 23.6025 0.146324C23.2874 0.0841712 22.9614 0.107477 22.6583 0.213824C22.6583 0.213824 1.63052 7.77157 0.42977 8.60857C0.17027 8.78858 0.08402 8.89283 0.04127 9.01657C-0.16648 9.61207 0.48002 9.87457 0.48002 9.87457L5.89952 11.6408C5.99106 11.6567 6.08503 11.651 6.17402 11.6243C7.40702 10.8458 18.5783 3.79132 19.224 3.55432C19.3253 3.52357 19.4003 3.55432 19.3838 3.62932C19.1198 4.53382 9.47252 13.1071 9.41927 13.1596C9.39338 13.1808 9.37304 13.208 9.35998 13.2388C9.34691 13.2697 9.34152 13.3032 9.34427 13.3366L8.84027 18.6248C8.84027 18.6248 8.62877 20.2748 10.2758 18.6248C11.4435 17.4556 12.564 16.4881 13.1258 16.0178C14.9895 17.3041 16.995 18.7268 17.8598 19.4678C18.0049 19.6088 18.1769 19.719 18.3655 19.7919C18.5542 19.8649 18.7556 19.899 18.9578 19.8923C19.7828 19.8608 20.0078 18.9586 20.0078 18.9586C20.0078 18.9586 23.8388 3.54232 23.9678 1.47607C23.9798 1.27357 23.997 1.14382 23.9985 1.00507C24.0054 0.844145 23.9894 0.683057 23.9513 0.526574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.74b152bb95126d40010a7e49a95663e6.svg";
export { ForwardRef as ReactComponent };